import React from 'react';

export default function Footer() {
  return (
    <footer className="border-t-2 border-black px-6 py-12 md:px-12 lg:px-24 mt-20 bg-stone-100">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
        <p className="font-bold text-lg">© 2026 Kevin Cogen</p>
        <div className="flex gap-6">
          <a href="https://www.linkedin.com/" className="font-bold hover:underline text-lg transition-all">
            LinkedIn
          </a>
          <a href="https://github.com/kevincogen" className="font-bold hover:underline text-lg transition-all">
            GitHub
          </a>
          <a href="kmurraycogen@gmail.com" className="font-bold hover:underline text-lg transition-all">
            Email
          </a>
        </div>
      </div>
    </footer>
  );
}
